import { useEffect, useState } from 'react';

/**
 * @template T
 * @typedef UseAsyncParams
 * @property {T} prev
 * @property {() => boolean} checkValid
 */

/**
 * Like `useMemo()`, but instead makes use of an async function.
 *
 * **NB:** Errors will simply be re-thrown. The async function is expected
 *     to handle its own errors.
 * @template T
 * @param {(params: UseAsyncParams<T>) => Promise<T>} getValueAsync
 * @param {any[]} deps
 * @returns {T}
 */
export default function useAsync(getValueAsync, deps) {
    const [value, setValue] = useState();

    console.assert(Array.isArray(deps), 'No deps array specified - always specify a deps array for useAsync() usages.');

    useEffect(() => {
        let cancelled = false;

        /** @type {UseAsyncParams<T>} */
        const params = {
            prev: value,
            checkValid() { return !cancelled; },
        };

        (async () => {
            let result;

            try {
                result = await getValueAsync(params);
            }
            catch (error) {
                throw error;
            }

            if (cancelled) return;

            setValue(result);
        })();

        return () => cancelled = true;
    }, deps);

    return value;
}